// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".need-more-box[data-v-108aa262] {\n  border: 1px solid #fde1c1;\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
